import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Modal, ActionBar, ButtonGroup, Loader } from 'shared-components';
import { HeadingContainer, AmountContainer, ModalWrapper } from './styles';
import Button from '../../../../components/Button';
import CancelButton from '../../../../components/CancelButton';

const PartialApprovalModal = ({
  acceptCallback,
  rejectCallback,
  transfer,
  page,
}) => {
  const intl = useIntl();
  const [loading, setLoading] = useState(false);

  const handleAccept = async e => {
    e.preventDefault();
    setLoading(true);
    acceptCallback(transfer.id);
  };

  const handleReject = async e => {
    e.preventDefault();
    setLoading(true);
    rejectCallback(transfer.id);
  };

  // Format the amount from cents to dollars with 2 decimal places
  const formatAmount = (amount) => `$ ${(amount / 100).toFixed(2)}`;

  return (
    <Modal>
      <ModalWrapper>
        <HeadingContainer>
          <h3>
            {intl.messages[`${page}-partial-approval-heading`]} {formatAmount(transfer.amount)}
          </h3>
          <p>
            {intl.messages[`${page}-partial-approval-message`]}
          </p>
          <AmountContainer>
            <div className="label">{intl.messages[`${page}-partial-approval-amount-label`]}</div>
            <div className="amount">{formatAmount(transfer.amount)}</div>
          </AmountContainer>
        </HeadingContainer>
        {loading ? (
          <Loader />
        ) : (
          <form>
            <ActionBar>
              <ButtonGroup reverse>
                <Button
                  buttonText={intl.messages[`${page}-partial-approval-accept-button`]}
                  buttonFor="accept-partial"
                  page={page}
                  onClick={handleAccept}
                  type="primary"
                />
                <CancelButton
                  buttonText={intl.messages[`${page}-partial-approval-reject-button`]}
                  onClick={handleReject}
                />
              </ButtonGroup>
            </ActionBar>
          </form>
        )}
      </ModalWrapper>
    </Modal>
  );
};

PartialApprovalModal.propTypes = {
  acceptCallback: PropTypes.func.isRequired,
  rejectCallback: PropTypes.func.isRequired,
  transfer: PropTypes.shape({
    id: PropTypes.number.isRequired,
    amount: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
  page: PropTypes.string.isRequired,
};

export default PartialApprovalModal;
